import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { FormNamedContainer as Component } from './form-named-container';
import type { IProps } from './models';

/** @widgetName FormNamedContainer */
export const FormNamedContainer = createWidget<unknown, IProps>({})(Component);
